var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4915 0.5085C11.2727 0.289784 10.976 0.166916 10.6667 0.166916C10.3573 0.166916 10.0606 0.289784 9.84185 0.5085L6.00001 4.35033L2.15818 0.5085C1.93814 0.295982 1.64344 0.178389 1.33755 0.181047C1.03165 0.183705 0.739034 0.306402 0.522725 0.522712C0.306415 0.739021 0.183718 1.03164 0.18106 1.33753C0.178402 1.64343 0.295996 1.93813 0.508513 2.15817L4.35035 6L0.508513 9.84183C0.397085 9.94945 0.308205 10.0782 0.247062 10.2205C0.185918 10.3629 0.153734 10.516 0.152388 10.6709C0.151042 10.8258 0.18056 10.9794 0.239221 11.1228C0.297882 11.2662 0.384511 11.3964 0.494052 11.506C0.603594 11.6155 0.733854 11.7021 0.877234 11.7608C1.02061 11.8195 1.17424 11.849 1.32915 11.8476C1.48406 11.8463 1.63715 11.8141 1.77949 11.753C1.92182 11.6918 2.05056 11.6029 2.15818 11.4915L6.00001 7.64967L9.84185 11.4915C10.0619 11.704 10.3566 11.8216 10.6625 11.819C10.9684 11.8163 11.261 11.6936 11.4773 11.4773C11.6936 11.261 11.8163 10.9684 11.819 10.6625C11.8216 10.3566 11.704 10.0619 11.4915 9.84183L7.64968 6L11.4915 2.15817C11.7102 1.93938 11.8331 1.64269 11.8331 1.33333C11.8331 1.02398 11.7102 0.727282 11.4915 0.5085Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.5d73d014a0eace8c1fbe961fa6f6acd0.svg";
export { ForwardRef as ReactComponent };